<template>
  <div>
    <el-dialog :title="title" :visible.sync="dialogVisible" width="900px" :before-close="handleClose" @close="handleClose"
      v-if="dialogVisible">
      <div class="ta-c pl30 pr30">
        <img class="seal-img" :src="detailObj.sealImage" alt="">
        <div class="mt15 fz24 fc3">{{ detailObj.sealName }}</div>
      </div>
      <div class="mt30 pl30 pr30">
        <div class="top-title flex-center">
          <img class="img-block" src="@/assets/user/icon-block.png" alt="">
          <span class="fc3 fz20">印章备案信息</span>
        </div>
        <div class="info-area mt20">
          <div class="info-item">印章名称：{{ detailObj.sealName }}</div>
          <div class="info-item">印章类型：{{ detailObj.sealType }}</div>
          <div class="info-item">申领时间：{{ $moment(detailObj.sealCreateTime).format('YYYY-MM-DD') }}</div>
        </div>
      </div>

    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    sealType: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      dialogVisible: false,
      loading: false,
      detailObj: {},
      title: '印章详情',
    };
  },
  methods: {
    show(item) {
      this.detailObj = item
      let type = this.sealType.find(li => item.code == li.code)
      if (type) {
        this.title = '印章详情-' + type.name
        this.detailObj.sealType = type.name
      }
      this.dialogVisible = true;
    },
    handleClose() {
      this.loading = false;
      this.dialogVisible = false;
    }
  }
};
</script>
<style lang="less" scoped>
.seal-img {
  width: 136px;
}

.top-title {
  .img-block {
    width: 12px;
    height: 12px;
    margin-right: 8px;
  }
}

.info-area {
  border-top: 1px solid rgb(238, 238, 238);
  border-right: 1px solid rgb(238, 238, 238);
  border-bottom: none;
  border-left: 1px solid rgb(238, 238, 238);

  .info-item {
    display: flex;
    padding: 15px 20px;
    font-size: 16px;
    border-bottom: 1px solid #eee;
  }
}

::v-deep .el-dialog__body {
  padding: 30px 20px 50px !important;
}
</style>
